export const About = () => {
  return <h1 className="title">About Page</h1>;
};
